module.exports = __webpack_public_path__ + "static/media/veryvell_1_filter.5f9b5fef.png";